import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  IconButton,
  Container,
  Slide,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CONSENT_KEY = 'cookie-consent';

export default function ConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setShowBanner(false);
    // Enable analytics if configured
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
      });
    }
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setShowBanner(false);
  };

  return (
    <Slide direction="up" in={showBanner} mountOnEnter unmountOnExit>
      <Paper
        elevation={8}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1400,
          bgcolor: 'background.paper',
          borderTop: 1,
          borderColor: 'divider',
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              py: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flexWrap: 'wrap',
            }}
          >
            <Typography variant="body2" sx={{ flex: '1 1 auto' }}>
              We use cookies and similar technologies to provide necessary
              functionality and enhance your experience. By clicking "Accept",
              you consent to the use of analytics cookies.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
              <Button
                variant="outlined"
                size="small"
                onClick={handleDecline}
              >
                Decline
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={handleAccept}
              >
                Accept
              </Button>
            </Box>
            <IconButton
              size="small"
              onClick={handleDecline}
              aria-label="close"
              sx={{ ml: 'auto' }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </Container>
      </Paper>
    </Slide>
  );
}
